import setupElements from './bond-request-new-elements';
import {bondRequestGridDisplay} from "./bond-request-grid";

const newButton  = $('button.js-bond-request-new');
const newBondRequestContainer = $('.js-bond-request-new-form-container');
const asideMenu = $('.js-new-bond-request-scrollpoints');

const newButtonClick = (e) => {
  newButton.hide();
  loadNewBondRequestForm();
};

const initCreateNewButton = () => {
  newButton.on('click', newButtonClick);
};

const updatePage = () => {
  bondRequestGridDisplay(false);
  newBondRequestContainer.show();
  asideMenu.show();
  $(document).trigger('on:RefreshScrollpoints');
  // $(document).trigger('on:PageUpdate');
};

const newBondRequestCb = () => {
  setupElements(newBondRequestContainer, asideMenu)
    .then(() => {
      updatePage();
    });
};

const loadNewBondRequestForm = () => {
  const rx = '/Sales/BondRequests/NewBondRequestForm';
  const form = $(newBondRequestContainer).find('form');
  if(form.length === 0) { // load form if it isn't there
    newBondRequestContainer.load(rx, null, newBondRequestCb);
  } else if(form.length === 1) {
    updatePage();
  }
};

export default function() {
  initCreateNewButton();
}

export const showNewButton = () => newButton.show();
